$(function() {
  const utmSource = getParam('utm_source')
  const utmMedium = getParam('utm_medium')
  const utmCampaign = getParam('utm_campaign')
  if(utmSource || utmMedium || utmCampaign) {
    const utm  = {}
    utmSource && (utm.utm_source = utmSource)
    utmMedium && (utm.utm_medium = utmMedium)
    utmCampaign && (utm.utm_campaign = utmCampaign)
    localStorage.setItem("visitor", JSON.stringify(utm));
  }
})

